var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash-screen light-mode",class:{
    visible: _vm.visible,
    mobile: _vm.$breakpoints.isMobile,
  },style:(`
    background: ${_vm.config.images.background};
  `)},[_c('a',{attrs:{"href":"/","target":"_blank"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.config.images.logo.img,"alt":_vm.config.images.logo.alt}})]),_c('h2',{staticClass:"splash-reality-typo font-SaolText",domProps:{"innerHTML":_vm._s(_vm.config.title)}}),_c('div',{staticClass:"splash-content"},[_c('div',{staticClass:"splash-catch-phrase",domProps:{"innerHTML":_vm._s(_vm.config.lang)}}),_c('language-selector',{attrs:{"langs":_vm.languages},on:{"choose-lang":_vm.langChosen}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }